export const enum OrganizationTabs {
  SETTING = 'setting',
  EDIT = 'edit',
}